import script from "./productManage.vue?vue&type=script&setup=true&lang=js"
export * from "./productManage.vue?vue&type=script&setup=true&lang=js"

import "./productManage.vue?vue&type=style&index=0&id=71739b32&lang=scss"
import "./productManage.vue?vue&type=style&index=1&id=71739b32&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71739b32"]])

export default __exports__